import { BASE_URL } from "../../data/BaseUrl";

// Phase 1: export the filtered tickets as CSV. Backend (getAllTickets) returns a
// CSV file when is_export=1; for "no data"/"not allowed" it returns JSON instead.
export const exportTickets = async (filters, TOKEN) => {
  const params = Object.entries({ ...filters, is_export: 1 })
    .filter(([, value]) => value !== "" && value !== null && value !== undefined)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
  const url = `${BASE_URL}/ticketSystem${params ? `?${params}` : ""}`;

  const response = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${TOKEN}` },
  });

  if (!response.ok) {
    const err = new Error(`Export failed with status ${response.status}`);
    err.status = response.status;
    try { err.body = await response.json(); } catch (_) {}
    throw err;
  }

  // Only treat as a file when content-type says so; else it's a JSON message.
  const contentType = response.headers.get("content-type") || "";
  const isCsv =
    contentType.includes("text/csv") ||
    contentType.includes("application/octet-stream");

  if (!isCsv) {
    let message = "Export failed.";
    let status = null;
    try {
      const json = await response.json();
      message = json?.message || message;
      status = json?.status ?? null;
    } catch (_) {}
    return { kind: "message", message, status };
  }

  const blob = await response.blob();
  const disposition = response.headers.get("content-disposition") || "";
  const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^;"'\n]+)["']?/i);
  const filename = match ? decodeURIComponent(match[1]) : `tickets_${Date.now()}.csv`;
  return { kind: "csv", blob, filename };
};

export const fetchTicketSystemIssueType = async (filters, TOKEN) => {
    let url = `ticketSystem/issue-type`;
  
    const filteredParams = Object.entries(filters)
      .filter(([key, value]) => value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
  
    if (filteredParams) {
      url += `?${filteredParams}`;
    }
  
    try {
      const response = await fetch(`${BASE_URL}/${url}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`HTTP ${response.status}: ${errorData.message || response.statusText}`);
      }
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      console.error("fetchTicketSystemIssueType=> ", error);
      throw error;
    }
  };